import { isNumber, isString } from 'lodash';
import styled from 'styled-components';

export interface ColumnsProps {
    $xs?: number | string;
    $md?: number | string;
    $lg?: number | string;
    $gap?: number;
}

export const Columns = styled.div<ColumnsProps>`
    display: grid;
    grid-gap: ${(props) => (props.$gap ? props.$gap + 'px' : '20px')};

    ${({ $xs }) => isNumber($xs) && `grid-template-columns: repeat(${$xs || 1}, minmax(0, 1fr));`}
    ${({ $xs }) => isString($xs) && `grid-template-columns: ${$xs};`}

    ${({ $md }) =>
        $md &&
        isNumber($md) &&
        `@media screen and (min-width:  768px) {
        grid-template-columns: repeat(${$md}, 1fr);
    }`}
    ${({ $md }) =>
        $md &&
        isString($md) &&
        `@media screen and (min-width:  768px) {
        grid-template-columns: ${$md};
    }`}

    ${({ $lg }) =>
        $lg &&
        isNumber($lg) &&
        `@media screen and (min-width:  1400px) {
        grid-template-columns: repeat(${$lg}, 1fr);
    }`}
    ${({ $lg }) =>
        $lg &&
        isString($lg) &&
        `@media screen and (min-width:  1400px) {
        grid-template-columns: ${$lg};
    }`}
`;
